import { orgBasicFun } from '../../../api/infoAPI';

export const getOrganizerInfo = async (type, id, setOrganizer, setLoading) => {
    setLoading(true);
    const res = await orgBasicFun(type, id);
    setOrganizer(res.data);
    setLoading(false);
};
